<template>
    <div>
        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-chart-bar mr-1"></i> Relatório dos Professores
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                        <!-- Period -->
                        <change-date :start-date="from" :end-date="to" locale="pt-BR" @changeDate="changeDate" class="ml-sm-auto flex-grow-1 mr-auto mr-sm-3 mt-3 mt-sm-0"></change-date>

                        <!-- Export -->
                        <b-button type="button" class="ml-2 ml-auto" variant="outline-primary" :disabled="loadingExport" @click="exportPdf">
                            <i class="fas fa-file-pdf mr-1" v-if="!loadingExport"></i>
                            <b-spinner small v-if="loadingExport" class="mr-1"></b-spinner>
                            Exportar em PDF
                        </b-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Content -->
        <div class="container">

            <!-- Filters -->
            <div class="row mb-2" v-if="canFilterTeachers">
                <div class="col-sm-4" >
                    <!-- Field -->
                    <b-form-group label="Professor">
                        <multiselect
                            v-model="teacher"
                            :options="teachers"
                            :loading="loadingTeacher"
                            track-by="id"
                            label="name"
                            @select="selectTeacher"
                            @remove="removeTeacher"
                            placeholder="Filtrar por Professor ..."
                            tag-placeholder="Filtrar Professor"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há professores disponíveis para exibir :(
                            </span>

                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-4" >
                    <!-- Field -->
                    <b-form-group label="Turmas">
                        <multiselect
                            v-model="group"
                            :options="groups"
                            :loading="loadingGroup"
                            track-by="id"
                            label="name"
                            @select="selectGroup"
                            @remove="removeGroup"
                            placeholder="Filtrar por Turma ..."
                            tag-placeholder="Filtrar Turma"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há turmas disponíveis para exibir :(
                            </span>
                        </multiselect>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-4">
                    <div class="card">
                        <div class="card-body">
                            <button type="button" class="close" v-b-tooltip.hover title="Redações Corrigidas">
                                <i class="fas fa-xs fa-info-circle"></i>
                            </button>
                            <div class="h2 font-weight-bold">
                                {{ qtdEssays }}
                            </div>
                            <div>
                                Redações Corrigidas
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 mb-4">
                    <div class="card">
                        <div class="card-body">
                            <button type="button" class="close" v-b-tooltip.hover title="Valor total de todas as correções usando o valor unitário de cada corretor no período">
                                <i class="fas fa-xs fa-info-circle"></i>
                            </button>
                            <div class="h2 font-weight-bold">
                                {{ priceTotal | currency('R$ ', 2, { decimalSeparator: ',' }) }}
                            </div>
                            <div>
                                Valor Total
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Chart Overview -->
            <b-card class="mb-4">
                <b-overlay :show="loading" rounded="sm">
                    <chart-count-essays :chart-data="chart"></chart-count-essays>
                </b-overlay>
            </b-card>

            <!-- Table Overview -->
            <b-card class="mb-4">
                <b-overlay :show="loading" rounded="sm">
                    <table-teacher :table="teachersData"></table-teacher>
                </b-overlay>
            </b-card>

            <!-- Table Overview By Day -->
            <b-card class="mb-4">
                <b-overlay :show="loading" rounded="sm">
                    <table-by-day :table="teachersByDayData"></table-by-day>
                </b-overlay>
            </b-card>

            <div v-if="revisorTeacher">
                <h5 class="m-0 mb-3 p-0 align-self-center">
                    Revisões
                </h5>
                <div class="row">
                    <div class="col-sm-6 mb-4">
                        <div class="card">
                            <div class="card-body">
                                <button type="button" class="close" v-b-tooltip.hover title="Redações Corrigidas">
                                    <i class="fas fa-xs fa-info-circle"></i>
                                </button>
                                <div class="h2 font-weight-bold">
                                    {{ qtdReviews }}
                                </div>
                                <div>
                                    Revisões Finalizadas
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-4">
                        <div class="card">
                            <div class="card-body">
                                <button type="button" class="close" v-b-tooltip.hover title="Valor total de todas as correções usando o valor unitário de cada corretor no período">
                                    <i class="fas fa-xs fa-info-circle"></i>
                                </button>
                                <div class="h2 font-weight-bold">
                                    {{ priceTotalReviews | currency('R$ ', 2, { decimalSeparator: ',' }) }}
                                </div>
                                <div>
                                    Valor Total
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- Chart Overview -->
                <b-card class="mb-4">
                    <b-overlay :show="loading" rounded="sm">
                        <chart-count-essays :chart-data="chartReview"></chart-count-essays>
                    </b-overlay>
                </b-card>
    
                <!-- Table Overview -->
                <b-card class="mb-4">
                    <b-overlay :show="loading" rounded="sm">
                        <table-teacher :qtdLabel="'Qtd. de Revisões Finalizadas'" :table="teachersReviewData"></table-teacher>
                    </b-overlay>
                </b-card>
    
                <!-- Table Overview By Day -->
                <b-card class="mb-4">
                    <b-overlay :show="loading" rounded="sm">
                        <table-by-day :qtdLabel="'Qtd. de Revisões Finalizadas'" :table="teachersReviewByDayData"></table-by-day>
                    </b-overlay>
                </b-card>

            </div>

        </div>

        <!-- Modal Export -->
        <b-modal
            id="exportPdf"
            size="sm"
            centered
            hide-footer
            hide-header
        >

            <div class="mx-auto py-2">

                <a :href="urlPdf" class="btn btn-primary btn-block" target="_blank" download>
                    <i class="fas fa-download mr-1"></i>
                    Download do PDF
                </a>
                <a :href="urlReviewPdf" v-if="revisorTeacher" class="btn btn-primary btn-block" target="_blank" download>
                    <i class="fas fa-download mr-1"></i>
                    Download do PDF de Revisões
                </a>

            </div>

        </b-modal>
    </div>
</template>

<script>
import ChangeDate from "./Shared/ChangeDate";
import ChartCountEssays from "./ChartCountEssays";
import TableTeacher from "./Table";
import TableByDay from "./TableByDay";

export default {
    components: {
        ChangeDate,
        ChartCountEssays,
        TableTeacher,
        TableByDay
    },
    props: ['from', 'to', 'teachers', 'canFilterTeachers', 'groups', 'revisorTeacher'],
    data() {
        return {
            loading: false,
            loadingTeacher: false,
            loadingGroup: false,
            loadingExport: false,
            qtdEssays: 0,
            priceTotal: 0,
            teachersData: [],
            teachersByDayData: [],
            chart: [],
            urlPdf: null,
            urlReviewPdf: null,
            filter: {
                start_date: this.from,
                end_date: this.to,
                teacher_id: null,
                group_id: null
            },
            teacher: null,
            group: null,
            qtdReviews: 0,
            priceTotalReviews: 0,
            chartReview: [],
            teachersReviewByDayData: [],
            teachersReviewData: [],
        }
    },
    created() {

        // Load
        this.load()

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/reports-teachers/essays', {
                params: {
                    start_date: this.$moment(this.filter.start_date).format('YYYY-MM-DD'),
                    end_date: this.$moment(this.filter.end_date).format('YYYY-MM-DD'),
                    teacher_id: this.filter.teacher_id,
                    group_id: this.filter.group_id
                }
            })
                .then(async (result) => {
                    const response = result.data.data;

                    this.priceTotal = response.priceTotal;
                    this.qtdEssays = response.qtdEssays;
                    this.teachersData = response.teachers;
                    this.chart = response.chart;
                    this.teachersByDayData = response.chartResumed;

                })
                .finally(() => this.loading = false)
                
            if(this.revisorTeacher){

                axios.get('/teacher/reports-teachers/reviews', {
                    params: {
                        start_date: this.$moment(this.filter.start_date).format('YYYY-MM-DD'),
                        end_date: this.$moment(this.filter.end_date).format('YYYY-MM-DD'),
                        teacher_id: this.filter.teacher_id,
                        group_id: this.filter.group_id
                    }
                })
                    .then(async (result) => {
                        const response = result.data.data;
    
                        this.priceTotalReviews = response.priceTotal;
                        this.qtdReviews = response.qtdReviews;
                        this.teachersReviewData = response.teachers;
                        this.chartReview = response.chart;
                        this.teachersReviewByDayData = response.chartResumed;
    
                    })
                    .finally(() => this.loading = false)
            }
            
        },

        async selectTeacher(value) {
            this.filter.teacher_id = await value.id;

            // Load
            await this.load()
        },

        async removeTeacher() {
            this.filter.teacher_id = await null;

            // Load
            await this.load()
        },

        async selectGroup(value) {
            this.filter.group_id = await value.id;

            // Load
            await this.load()
        },

        async removeGroup() {
            this.filter.group_id = await null;

            // Load
            await this.load()
        },

        async changeDate(dateFilters) {
            this.filter.start_date = await dateFilters.startDate;
            this.filter.end_date = await dateFilters.endDate;

            // Load
            await this.load()
        },

        exportPdf() {
            this.loadingExport = true;
            axios.get('/teacher/reports-teachers/essays/export', {
                params: {
                    start_date: this.$moment(this.filter.start_date).format('YYYY-MM-DD'),
                    end_date: this.$moment(this.filter.end_date).format('YYYY-MM-DD'),
                    teacher_id: this.filter.teacher_id,
                    group_id: this.filter.group_id
                }
            })
                .then(async (result) => {
                    const response = result.data.data;

                    this.urlPdf = response.urlPdf;

                    this.$bvModal.show('exportPdf');
                })
                .finally(() => this.loadingExport = false)
                
            if(this.revisorTeacher){
                axios.get('/teacher/reports-teachers/reviews/export', {
                    params: {
                        start_date: this.$moment(this.filter.start_date).format('YYYY-MM-DD'),
                        end_date: this.$moment(this.filter.end_date).format('YYYY-MM-DD'),
                        teacher_id: this.filter.teacher_id,
                        group_id: this.filter.group_id
                    }
                })
                    .then(async (result) => {
                        const response = result.data.data;

                        this.urlReviewPdf = response.urlPdf;

                        this.$bvModal.show('exportPdf');
                    })
                    .finally(() => this.loadingExport = false)
                }
        }

        
    }
}
</script>

<style scoped>

</style>
